//Local settings

export let appConfiguration = {
  prefix : "ctl",
  ENVIRONMENT : "DEV",  //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']


  LOCAL_RASERVICE_Url : "",
  DEV_RASERVICE_Url : "https://raservice.opraco.com/",
  COMMERCIAL_RASERVICE_Url : "https://raservice.opraco.com/",

  LOCAL_CATALYST_Url : "",
  DEV_CATALYST_Url : "https://catalystservice.opraco.com/",
  // DEV_CATALYST_Url : "http://whiztec.ddns.net:8082/",
  COMMERCIAL_CATALYST_Url : "https://catalystservice.opraco.com/"
}


// export let IMAGES_BASE_URL = "http://dev.cdn01.anydatapoint.com/";
export let IMAGES_BASE_URL = "";
export let jazzbaManagePurchasesUrl = "/#/app/transactions/purchaseOrder"
export let jazzbaManageSuppliersUrl = "/#/app/buy-supply/supplier"

export let copyRight = "2020"





// Commertial Settings


// export let appConfiguration = {
// //   prefix : "ctl",
// //   ENVIRONMENT : "DEV",  //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']
// //
// //
// //   LOCAL_RASERVICE_Url : "",
// //   DEV_RASERVICE_Url : "http://dev-raservice.opraco.com/",
// //   COMMERCIAL_RASERVICE_Url : "https://dev-raservice.opraco.com/",
// //
// //   LOCAL_CATALYST_Url : "",
// //   DEV_CATALYST_Url : "https://dev-catalystservice.opraco.com/",
// //   // DEV_CATALYST_Url : "http://whiztec.ddns.net:8082/",
// //   COMMERCIAL_CATALYST_Url : "https://dev-catalystservice.opraco.com/"
// // }
// //
// //
// // export let IMAGES_BASE_URL = "https://anydatapoint.net/";
// // export let jazzbaManagePurchasesUrl = "https://dev-adminpanel.opraco.com/#/app/transactions/purchaseOrder"
// // export let jazzbaManageSuppliersUrl = "https://dev-adminpanel.opraco.com/#/app/buy-supply/supplier"
// //
// // export let copyRight = "2020"

// Stage Settings


// export let appConfiguration = {
//   prefix : "ctl",
//   ENVIRONMENT : "DEV",  //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']
//
//
//   LOCAL_RASERVICE_Url : "",
//   DEV_RASERVICE_Url : "http://dev-raservice.opraco.com/",
//   COMMERCIAL_RASERVICE_Url : "https://dev-raservice.opraco.com/",
//
//   LOCAL_CATALYST_Url : "",
//   DEV_CATALYST_Url : "https://dev-catalystservice.opraco.com/",
//   // DEV_CATALYST_Url : "http://whiztec.ddns.net:8082/",
//   COMMERCIAL_CATALYST_Url : "https://dev-catalystservice.opraco.com/"
// }
//
//
// export let IMAGES_BASE_URL = "https://anydatapoint.net/";
// export let jazzbaManagePurchasesUrl = "https://dev-adminpanel.opraco.com/#/app/transactions/purchaseOrder"
// export let jazzbaManageSuppliersUrl = "https://dev-adminpanel.opraco.com/#/app/buy-supply/supplier"
//
// export let copyRight = "2020"
